import React from 'react';
import CartItemDetails from '../CartItemDetails/CartItemDetails';
import { useSelector } from 'react-redux';
import { selectCartItems } from '../../Utilities/cartSelectors';
import { useNavigate } from 'react-router-dom';
import './CartList.css';

function CartList({ mobileCartData }) {
    const cart = useSelector(selectCartItems) || [];
    const navigate = useNavigate();

    // Use mobileCartData if available, otherwise fallback to Redux cart
    const itemsToRender = mobileCartData?.items?.length ? mobileCartData.items : cart;

    return (
        <div className="cart-list-container">
            <div className="cart-list-header">
                <h3>Your Classes ({itemsToRender.length})</h3>
            </div>

            {itemsToRender.length > 0 ? (
                <div className="cart-items-container">
                    <div className="cart-items-scrollable">
                        {itemsToRender.map((item) => (
                            <CartItemDetails key={item.id} item={item} />
                        ))}
                    </div>
                </div>
            ) : (
                <div className="empty-cart">
                    <p>Your cart is empty</p>
                    <button
                        className="browse-courses-btn"
                        onClick={() => navigate('/courses')}
                    >
                        Browse Courses
                    </button>
                </div>
            )}
        </div>
    );
}

export default CartList;
